import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  CircularProgress,
} from "@material-ui/core";
import { X as Close } from "icons";
import { makeStyles } from "@material-ui/core/styles";
import { blueGrey } from "@material-ui/core/colors";
import { generatedLabels } from "api/shipment";

const useStyles = makeStyles((theme) => ({
  contentContainer: {
    padding: 10,
  },
  container: {
    display: "flex",
    flexDirection: "column",
    padding: 0,
    paddingTop: 20,
    paddingBottom: 20,
  },
  dialogTitle: { padding: "0.25rem 1rem", backgroundColor: blueGrey[100] },
  labelRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "5px 5px",
    marginBottom: "8px",
    backgroundColor: blueGrey[50],
    borderRadius: "4px",
  },
  labelDate: {
    flex: 1,
    fontSize: "14px",
    color: theme.palette.text.primary,
  },
  viewButton: {
    marginLeft: "12px",
  },
  emptyMessage: {
    padding: "16px",
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "24px",
  },
  titleWithLoader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
}));

const GeneratedLabelModal = (props) => {
  const classes = useStyles();
  const [labels, setLabels] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (props.open) {
      setIsLoading(true);
      generatedLabels({
        params: {},
        responseSetter: (res) => {
          setIsLoading(false);
          setLabels(res);
        },
      });
    }
  }, [props.open]);

  const handleViewLabel = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      scroll="paper"
      open={props.open}
      keepMounted
      aria-labelledby="generated-label-dialog-title"
      onClose={(_, reason) => {
        if (reason === "backdropClick") {
          props.onClose();
        }
      }}
    >
      <DialogTitle
        id="generated-label-dialog-title"
        className={classes.dialogTitle}
        color="primary"
      >
        {isLoading ? (
          <div className={classes.titleWithLoader}>
            <CircularProgress size={20} />
            <span>Generated Labels</span>
          </div>
        ) : (
          "Generated Labels"
        )}
      </DialogTitle>
      <DialogContent dividers={true} className={classes.contentContainer}>
        <div className={classes.container}>
          {isLoading ? (
            <div className={classes.loadingContainer}>
              <CircularProgress />
            </div>
          ) : labels && labels.results && labels.results.length > 0 ? (
            <Paper square variant="elevation">
              <Grid container spacing={0} className={classes.container}>
                {labels.results.map((label) => (
                  <Grid item xs={12} key={label.url}>
                    <div className={classes.labelRow}>
                      <div className={classes.labelDate}>
                        {new Date(label.generated_at).toLocaleString()}
                      </div>
                      <Button
                        onClick={() => handleViewLabel(label.url)}
                        variant="contained"
                        color="primary"
                        size="small"
                        className={classes.viewButton}
                      >
                        View
                      </Button>
                    </div>
                  </Grid>
                ))}
              </Grid>
            </Paper>
          ) : (
            <div className={classes.emptyMessage}>
              No generated labels available.
            </div>
          )}
        </div>
      </DialogContent>
      <DialogActions className={classes.dialogTitle} role="close">
        <Button
          onClick={props.onClose}
          variant="contained"
          color="primary"
          size="small"
        >
          <Close color="white" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GeneratedLabelModal;
